export default __webpack_public_path__ + "static/media/noexpl_12_DE.9a1ddd8c.png";